<template>
  <div class="number__config">
    <div class="number__options">
      <div
        class="optionBox"
        id="regional"
        @click="getNumbers('regional')"
        :class="{ 'optionBox--active': isActive('regional') }"
      >
        <span>
          Regional
          <br />e.g. 0203, 0161 ...
        </span>
      </div>
      <div
        class="optionBox"
        id="national"
        @click="getNumbers('national')"
        :class="{ 'optionBox--active': isActive('national') }"
      >
        <span>
          National
          <br />03
        </span>
      </div>
      <div
        class="optionBox"
        id="freephone"
        @click="getNumbers('freephone')"
        :class="{ 'optionBox--active': isActive('freephone') }"
      >
        <span>
          Freephone
          <br />0808 + £{{freephoneSurcharge}}*
        </span>
      </div>
    </div>
    <div v-if="product === 'CleverNumbers'">
      <ul class="number__cn-routing">
        <li class="cn-route-item">
          <router-link
            :to="{ name: 'NumberSelector', params: { routeNumberType: type, freephoneSurcharge: freephoneSurcharge } }"
            class="cn-route"
          >
            <span class="route-number">1</span>
            <span class="route-name">Pick your Clever Number</span>
          </router-link>
        </li>
        <li class="cn-route-item">
          <router-link
            :to="{ name: 'NumberRouter', params: {} }"
            @click.native.capture="allowNavigation"
            class="cn-route"
          >
            <span class="route-number">2</span>
            <span class="route-name">Route your Clever Number</span>
          </router-link>
        </li>
      </ul>
      <hr />
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import NumberSelector from "./NumberSelector.vue";
import { eventBus } from "../main";

function setActiveNumberType(numberTypes, numberType) {
  numberTypes.forEach((num) => {
    num.active = false;
  });
  numberTypes.find((n) => n.name === numberType).active = true;
}

export default {
  props: {
    product: String
  },
  mounted() {
    setActiveNumberType(this.numberTypes, this.type);

    if(!this.$route.name) {
      this.$router.push({
        name: "NumberSelector",
        params: { routeNumberType: this.type, freephoneSurcharge: this.freephoneSurcharge },
      });
    }
  },
  watch: {
    type: function(type){
      setActiveNumberType(this.numberTypes, type);
    }
  },
  data() {
    return {
      numberTypes: [
        { name: "regional", active: false },
        { name: "national", active: false },
        { name: "freephone", active: false },
      ],
    };
  },
  computed: {
    type() {
      return this.$store.getters.numberType;
    },
    freephoneSurcharge() {
      if(this.product === 'CleverNumbers'){
        return 3;
      } else{
        return 5;
      }
    }
  },
  methods: {
    getNumbers(numberType) {
      this.$store.commit('setNumberType', numberType);
      eventBus.$emit('type-changed', numberType);
      setActiveNumberType(this.numberTypes, numberType);
      this.$router.push({
        name: "NumberSelector",
        params: { routeNumberType: this.type, freephoneSurcharge: this.freephoneSurcharge },
      });
    },
    isActive(numberType) {
      return this.numberTypes.find((n) => n.name === numberType).active;
    },
    allowNavigation(event) {
      const cart = this.$store.getters.numbersCart;

      if (cart.length < 1){
        event.preventDefault();
      }
    }
  },
  components: {
    NumberSelector,
  },
};
</script>

<style></style>
